import { usePatientQuestionnairesMarkOnFileMutation } from "../../../../api/questionnaires/patientQuestionnaires/usePatientQuestionnairesMarkOnFileMutation";
import { useAppTranslation } from "../../../../i18n/useAppTranslation";
import { uiNotification } from "../../../../services/UINotificationService";

export function useMarkAsOnFile() {
  const { tCommon: t } = useAppTranslation.Common();

  const { mutate, isLoading } = usePatientQuestionnairesMarkOnFileMutation({
    onError: () => {
      uiNotification.error(t("error.fallback"));
    },
    onSuccess: () => {
      uiNotification.success(t("patientQuestionnaires.success.update"));
    },
  });

  return {
    mark: (procedureId, questionnaireId) => {
      mutate({
        procedureId,
        questionnaireIds: [questionnaireId],
        mark: true,
      });
    },

    unmark: (procedureId, questionnaireId) => {
      mutate({
        procedureId,
        questionnaireIds: [questionnaireId],
        mark: false,
      });
    },

    isLoading,
  };
}
